import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import Routes from './routes';
import Store from './store';
import registerServiceWorker from './util/registerServiceWorker';
import './styles';

/**
 * 前端入口文件
 * Frontend scripts 
 *
 * @reference
 * [React官网](https://facebook.github.io/react/)
 * [React China](http://react-china.org)
 */
ReactDOM.render(
  <Provider store={Store}>
    <Routes />
  </Provider>,
  document.getElementById('root')
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./usr/lib/ui/src/index.js